import { Megaphone } from "lucide-react";

/**
 * Sprint 3 Item 2 — Sponsored ad card.
 *
 * Rendered when the backend's `ads_enabled` feature flag is on, every
 * 4th result. Matches the Piqpath B&W minimalist theme but visually
 * distinct: faint grey background, "SPONSORED" label top-right, the
 * whole card opens the advertiser deeplink in a new tab.
 */
export default function AdCard({ card }) {
    if (!card) return null;
    const { headline, body, sponsor, deeplink_url, id } = card;
    return (
        <a
            href={deeplink_url}
            target="_blank"
            rel="noopener noreferrer sponsored"
            data-testid={`ad-card-${id}`}
            className="relative block overflow-hidden rounded-2xl border border-[#E5E5E5] bg-[#FAFAFA] p-5 transition hover:border-[#0A0A0A] hover:bg-[#F5F5F5]"
        >
            <span
                className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-[#737373]"
                data-testid="ad-sponsored-label"
            >
                <Megaphone size={9} strokeWidth={2.5} className="text-[#0A0A0A]" />
                Sponsored
            </span>
            <div className="flex flex-col gap-2 pr-24">
                <div className="text-[16px] font-semibold tracking-tight text-[#0A0A0A]">
                    {headline}
                </div>
                <div className="text-[13.5px] leading-[1.5] text-[#525252]">{body}</div>
                {sponsor && (
                    <div className="mt-1 text-[11px] uppercase tracking-[0.14em] text-[#A3A3A3]">
                        by {sponsor}
                    </div>
                )}
            </div>
        </a>
    );
}
